import React from 'react'
import { withIcon } from '../../withIcon'

function VoiceIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
      <path d="M9.99976 19.375V4.625C9.99976 4.27982 10.2796 4 10.6248 4C10.9699 4 11.2498 4.27982 11.2498 4.625V19.375C11.2498 19.7202 10.9699 20 10.6248 20C10.2796 20 9.99976 19.7202 9.99976 19.375ZM13.9998 17.5977V6.40234C14 6.05743 14.2798 5.77747 14.6248 5.77734C14.9698 5.77735 15.2495 6.05735 15.2498 6.40234V17.5977C15.2495 17.9426 14.9698 18.2227 14.6248 18.2227C14.2798 18.2226 14 17.9426 13.9998 17.5977ZM5.99976 14.042V9.95801C5.99995 9.613 6.2797 9.33301 6.62476 9.33301C6.96981 9.33301 7.24956 9.613 7.24976 9.95801V14.042C7.2496 14.387 6.96984 14.667 6.62476 14.667C6.27967 14.667 5.99991 14.387 5.99976 14.042ZM17.9998 14.042V9.95801C18 9.61307 18.2798 9.33313 18.6248 9.33301C18.9698 9.33302 19.2496 9.61301 19.2498 9.95801V14.042C19.2496 14.387 18.9698 14.667 18.6248 14.667C18.2797 14.6669 17.9999 14.387 17.9998 14.042Z" fill={color} />
    </svg>
  )
}

export default withIcon(VoiceIcon)
